"use client";
import Icon from '@/components/primitives/icon';
import React from 'react'

export default function Loading() {
  return (
    <div>
      {/* HEADER */}
      <div className="bg-scoreboard-header-gradient py-6 relative overflow-hidden z-0">
        {/* SPORT SPLASH */}
        <div className="bg-scoreboard-splash-gradient z-[1] absolute left-0 -top-8 w-[15.833rem] h-[15.833rem]"></div>
        {/* <Icon
          name={
            SPORTS.find((sport) => sport.id === params.sport)?.icon ||
            "football"
          }
          className="fill-white absolute left-0 -top-8 w-[15.833rem] h-[15.833rem] opacity-[0.05] z-0"
        /> */}
        {/* PARTICLE SPLASH */}
        <div className="absolute right-0 top-0 w-[22.4rem] h-[18rem] sm:bg-[url('/images/ui/scoreboard-particles.png')] bg-cover bg-center bg-no-repeat"></div>
        <div className="container">
          <div className="flex flex-row justify-between relative z-[2] items-center flex-wrap">
            <div className="flex flex-col pr-6 pb-6">
              <h1 className="text-display-xl uppercase text-white">
                {/* {params.sport} Scores */}
              </h1>
              <h3 className="text-title-lg-medium uppercase text-secondary">
                {/* All Games in the {params.sport} */}
              </h3>
            </div>
            <div className="flex flex-row gap-3 desktop-grid:gap-7 flex-wrap">
              <div className="flex flex-col p-4 gap-2 min-w-[8.8rem] desktop-grid:min-w-[11.7rem] border rounded-xl border-white/20 relative overflow-hidden">
                <Icon
                  name="flash"
                  className="absolute -right-6 top-3 w-[5.5rem] h-[5.5rem] fill-white opacity-10"
                ></Icon>
                <hr className="border-primary-600 mix-blend-screen w-6" />
                <div className="text-label-sm-medium uppercase text-white">
                  Games
                </div>
              </div>
              <div className="flex flex-col p-4 gap-2 min-w-[8.8rem] desktop-grid:min-w-[11.7rem] border rounded-xl border-white/20 relative overflow-hidden">
                <Icon
                  name="ticket-group"
                  className="absolute -right-6 top-3 w-[5.5rem] h-[5.5rem] fill-white opacity-10"
                ></Icon>

                <hr className="border-primary-600 mix-blend-screen w-6" />
                <div className="text-label-sm-medium uppercase text-white">
                  Picks
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container min-h-[100vh]">

      </div>
    </div>
  )
}
